import { render, staticRenderFns } from "./LexologyList.vue?vue&type=template&id=18c0374f&"
import script from "./LexologyList.vue?vue&type=script&lang=js&"
export * from "./LexologyList.vue?vue&type=script&lang=js&"
import style0 from "./LexologyList.vue?vue&type=style&index=0&id=18c0374f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports